import Vue from 'vue'
function hightLight(el, binding) {
  const match = binding.value.trim()
  const reg = new RegExp(match, 'g')
  const txt = binding.arg
  let str = ''
  if (txt) {
    str = txt.replace(reg, `<i style="color:#F52525" class='hightLight-match'>${match}</i>`)
  } else {
    str = ''
  }
  el.innerHTML = str
}
Vue.directive('hightLight', {
  bind(el, binding) {
    hightLight(el, binding)
  },
  componentUpdated(el, binding) {
    hightLight(el, binding)
  }
})
